import { Factory } from '../../services/Factory';
import { INotificationService } from '../../services/notification';
import { IRootScope } from '../../IRootScope';

interface SaveSearchModalScope extends any {
  project: any;
  search:any;
  save: Function;
  close: Function;
}

export class SaveSearchModalController {
  constructor(rootScope: IRootScope, scope:SaveSearchModalScope, project: any, search:any, searchService:any, modal: any, notificationService: INotificationService) {
    scope.project = project;
    scope.search = search;
    scope.save = () => {
      searchService.Save(project, search).then((search: any) => {
        scope.search.id = search.id;
        rootScope.$broadcast("AdvancedSearch.Saved");
        modal.close();
      }, () => {
          notificationService.addError({
            title: "Error Saving Search",
            timeout: 5000
          });
        }
      );
    };
    scope.close = () => {
      modal.close();
    };
  }
}

frontendApp.controller("SaveSearchModalController", ["$rootScope", "$scope", "project", "search", "AdvancedSearchService", "$uibModalInstance", "NotificationService", Factory.Create(SaveSearchModalController)]);